import React from 'react';
import { privacyPolicyContent } from '../data';
import { PrivacyPolicyProps } from '../types';
import PrivacyPolicyPresentation from './PrivacyPolicyPresentation';

const PrivacyPolicyContainer: React.FC<PrivacyPolicyProps> = ({ 
  className,
  id = 'privacy-policy'
}) => {
  const { heading, lastUpdated, sections, disclaimer } = privacyPolicyContent;
  const props = {
    id,
    heading,
    lastUpdated,
    sections
  };

  // Add disclaimer only if it exists
  if (disclaimer) {
    Object.assign(props, { disclaimer });
  }

  return <PrivacyPolicyPresentation {...props} />;
};

export default PrivacyPolicyContainer;